export default __webpack_public_path__ + "static/spitz-screens-mobile-4983a36482736cc61f5d9420d55ea829.jpg";